import { render } from "./SucursalesAdminView.vue?vue&type=template&id=46d6ad53&ts=true"
import script from "./SucursalesAdminView.vue?vue&type=script&lang=ts"
export * from "./SucursalesAdminView.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/frontend-marketbo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__